export const booleanFromString = text => {
  if (text === 'true') return true
  if (text === 'false') return false
}
